/* eslint-disable @angular-eslint/no-output-rename */
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { GroupKey } from '../../services/financial-planning.service';


@Component({
  selector: 'app-add-group-key',
  templateUrl: './add-group-key.component.html',
  styleUrls: ['./add-group-key.component.scss']
})
export class AddGroupKeyComponent implements OnInit {

  @Output('hide') hide: EventEmitter<any> = new EventEmitter();
  @Output('save') save: EventEmitter<any> = new EventEmitter<GroupKey>();
  
  @ViewChild('newGroupKey') newGroupKey: any | undefined; 
  @ViewChild('newGroupKeyName') newGroupKeyName: any | undefined;

  errormessage = '';

  constructor() { }

  ngOnInit(): void {
    this.errormessage = '';
  }

  fieldChanged(elem: HTMLInputElement) {
    this.errormessage = elem.value ? '' : 'Group Key and Name required';

  }

  addNewGroupKey() {
    if(!(this.newGroupKey && this.newGroupKey.nativeElement.value)) {
      this.errormessage = 'Group Key required';
      return;
    }

    if(!(this.newGroupKeyName && this.newGroupKeyName.nativeElement.value)) {
      this.errormessage = 'Group Key Name required';
      return;
    }

    const newGroupKey: GroupKey = {
      groupKey: this.newGroupKey.nativeElement.value,
      name: this.newGroupKeyName.nativeElement.value
    };

    this.save.emit(newGroupKey);
  }

  canceladdNewGroupKey() {
    this.hide.emit();
  }

}
